import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

import { del, get, post, put } from "../../helpers/api_helper"

import { APIServerIP } from "../../helpers/Sats_api_helper"

const initialEveState = {
   newTicketList: [],
  TicketListWithvenue: [],
  isSuccessfullyAdded: false,
  isUserEdit: false,
}

const ticketFormSlice = createSlice({
  name: "TicketFromValue",
  initialState: initialEveState,
  reducers: {
    setTicketList: (state, action) => {
      state.newTicketList = action.payload
     },

    setTicketListVenue: (state, action) => {
      state.TicketListWithvenue = action.payload
    },
    setUserEdit: (state, action) => {
      state.isUserEdit = true
    },
    setTicketSuccessfullyAdded: (state, action) => {
      state.isSuccessfullyAdded = true
    },
    resetTicket: (state, action) => {
      state.isSuccessfullyAdded = false
      state.isUserEdit = false
    },
  },
})

export const createTicket = (image, values) => {
  return async dispatch => {
     const formData = new FormData()
    formData.append("file", image)
    formData.append("values", JSON.stringify(values))

    dispatch(resetTicket())
    await fetch(`${APIServerIP}manage-ticket/create-ticket`, {
      method: "POST",
      headers: {
        Accept: "application/json",
       },
      body: formData,
    })
      .then(res => {
        // console.log("res", res)
        if (res.status === 200) {
          dispatch(setTicketSuccessfullyAdded())
        }
      })
      .catch(err => {
        console.log("try error", err)
      })

 
  }
}

export const updateTicket = (image, values) => {
  return async dispatch => {
 
    const formData1 = new FormData()
    formData1.append("file", image)
      formData1.append("values", JSON.stringify(values))
 

    dispatch(resetTicket())
    await fetch(`${APIServerIP}manage-ticket/update-ticket`, {
      method: "POST",
      headers: {
        Accept: "application/json",
       },
      body: formData1,
    })
      .then(res => {
         if (res.status == 200) {
          dispatch(setTicketSuccessfullyAdded())
          localStorage.removeItem("editUser")
        }
      })
      .catch(err => {
        console.log("Updatetry error", err)
      })
  }
}

export const deleteTicket = id => {
  return async dispatch => {
    try {
      dispatch(resetTicket())
      const responseData = await post(
        `${APIServerIP}manage-ticket/delete-ticket`,
        id
      )

      if (responseData.response_code === 200) {
         dispatch(setTicketSuccessfullyAdded())
      }
    } catch (error) {
      console.log("try error", error)
    }
  }
}
export const activeInactiveTicket = data => {
  return async dispatch => {
    try {
      dispatch(resetTicket())
      const responseData = await post(
        `${APIServerIP}manage-ticket/active-inactive-ticket-event`,
        data
      )

      if (responseData.response_code === 200) {
         dispatch(setTicketSuccessfullyAdded())
      }
    } catch (error) {
      console.log("try error", error)
    }
  }
}

export const editUser = data => {
  return async dispatch => {
    try {
      localStorage.setItem("editUser", JSON.stringify(data))
      dispatch(setUserEdit())
    } catch (err) {
      console.log("editUsererr", err)
    }
  }
 
}

export const fetchTicket = () => {
  return async dispatch => {
    try {
      let responseData = await get(`${APIServerIP}manage-ticket/fetch-tickets`)
       if (responseData.response_code === 200) {
        dispatch(setTicketList(responseData.data))
        dispatch(resetTicket())
      }
    } catch (error) {
      console.log("try error fetch", error)
    }
  }
}

export const PublishTicket = data => {
  return async dispatch => {
    try {
      let responseData = await post(
        `${APIServerIP}manage-ticket/edit-publish-ticket-event`,
        data
      )
       if (responseData.response_code === 200) {
        dispatch(setTicketSuccessfullyAdded())
      }
    } catch (error) {
      console.log("try error fetch", error)
    }
  }
}
export const fetchTicketandVenue = () => {
  return async dispatch => {
    try {
      let responseData = await get(
        `${APIServerIP}manage-ticket/fetch-ticket-event-and-venues-publish`
      )
       if (responseData.response_code === 200) {
        dispatch(setTicketListVenue(responseData.data))
        dispatch(resetTicket())
      }
    } catch (error) {
      console.log("try error fetch", error)
    }
  }
}

export const {
  setTicketList,
  setTicketSuccessfullyAdded,
  resetTicket,
  setTicketListVenue,
  setUserEdit,
} = ticketFormSlice.actions

export default ticketFormSlice.reducer
